jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	})
	if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

  } else {
  	// open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }

  // attempt at overriding Bootstrap hover events
   $('nav#main-nav #navbarNavDropdown ul#main-menu li').hover(function () {
  	if ($(window).width() > 999) {
	  	var dropdown = $(this).find('ul.dropdown-menu');
	  	dropdown.addClass('active')
	  }
	  }, function(){
	  	var dropdown = $(this).find('ul.dropdown-menu');
		  	dropdown.removeClass('active')
	});

    $('.navbar-hamburger').click (function (e) {
	  	$(this).parents('body').toggleClass('menu-open');

	  	if ($('ul#main-menu').find('.search').length === 0) {
	  		$('header .search').clone().prependTo('ul#main-menu');
	  	}

	  	var menuLinks = $('nav#main-nav #navbarNavDropdown ul#main-menu > li > a.dropdown-toggle');
	  	menuLinks.each(function (i) {
			$(this).attr('data-toggle', '');
			$(this).attr('data-bs-toggle', '');
		})
	})


  // Get the button:
	// let mybutton = document.getElementById("btt");

	// When the user scrolls down 20px from the top of the document, show the button
	// window.onscroll = function() {scrollFunction()};

	// function scrollFunction() {
	//   if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	//     // mybutton.style.display = "block";
	//    	$(mybutton).css('display', 'block');
	//   } else {
	//     // mybutton.style.display = "none";
	//     $(mybutton).css('display', 'none');
	//   }
	// }

	// When the user clicks on the button, scroll to the top of the document
	// if($('#btt')) {
	// 	$('#btt').click(function(){
		
	// 	  document.body.scrollTop = 0; // For Safari
	// 	  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	// 	});
	// }

	// BLOCK: Video Full Width
	$('.toggle-play img').click (function (e) {
		var target = $(e.target);
		var buttons = target.parent();

		var video = target.parents('.block-video-full').find('video')[0];
		
		if (video.paused === true) {
			video.play();
			buttons.find('.play').hide();
			buttons.find('.pause').show();
			
		} else {
			video.pause();
			buttons.find('.pause').hide();
			buttons.find('.play').show();
		}
	})


	// BLOCK: Accordion
	if ($('.accordion.two-levels .accordion-button-inner')) {
		$('.accordion.two-levels .accordion-button-inner').click (function (e) {
			var target = $(this);
			var content = target.next('.accordion-body-inner');

			if (content.hasClass('open')) {
				content.slideUp();
				content.removeClass('open');
				target.removeClass('open');
			} else {
				content.slideDown();
				content.addClass('open')
				target.addClass('open');
			}
		})
	}

	// BLOCK: Carousel
	$('.slick-carousel').slick({

	});

	// Lightbox for carousel videos
	$('.slick-carousel .slide.has-video .media').click (function (e) {
		var target = $(this); 
		var lightbox = target.parents('.block-carousel').find('.lightbox');
		var videoElement = lightbox.find('video');
		var videoUrl = target.find('img').attr('data-video');
		var source = videoElement.find('source');

		source.attr('src', videoUrl);

		if (videoUrl.indexOf('.mp4') > 0 || videoUrl.indexOf('.mov') > 0) {
            source.attr('type', 'video/mp4');
        }

        videoElement[0].load();
		lightbox.show();
		$('body').addClass('dimmed');
		videoElement[0].play();

		lightbox.find('.close-video').click (function (e) {
			videoElement[0].pause();
			videoElement[0].currentTime = 0;
			lightbox.hide();
			$('body').removeClass('dimmed');
		})
	})

	// Lightbox for Celebration page
	$('.page-celebration .open-lightbox a.cta-link').click (function (e) {
		e.preventDefault();


		var lightbox = $('.lightbox');
		var columns = $(this).closest('.wp-block-columns');
		var contentContainer = lightbox.find('.content-container');

		columns.clone().appendTo(contentContainer);

		lightbox.show();
		$('body').addClass('dimmed');

		lightbox.find('.close-lightbox').click (function (e) {
			contentContainer.empty();
			lightbox.hide();
			$('body').removeClass('dimmed');
		})
	})

	// BLOCK: Tabbed Content
	$('.block-tabs .tab-labels .label').click (function (e) {
		var target = $(this);
		var dataTab = $(this).attr('data-tab-id');

		if (!target.hasClass('active')) {
			var parent = target.closest('.block-tabs');

			target.siblings('.active').removeClass('active');
			target.addClass('active');

			if ($(window).width() > 1000) {
				parent.find('.tab-content > div.active').removeClass('active');
				parent.find('.single-content[data-tab-id="' + dataTab + '"]').addClass("active");
			} else {
				target.siblings('.mobile-tab-content.active').removeClass('active');
				target.siblings('.mobile-tab-content[data-tab-id="' + dataTab + '"]').addClass("active");
			}
		}
	})


	// BLOCK: Hero Video
	$('.block-video-hero .toggle-play').click (function () {
		var target =  $(this);
		var video = target.siblings('video')[0];

        if (video.paused === true && target.find('.play').css('display') != 'none') {
            video.play();
            target.find('.play').hide();
            target.find('.pause').show();
        } else {
            video.pause();
            target.find('.pause').hide();
            target.find('.play').show();
        }
	})

	var videos = $('.block-video-full, .block-video-hero').find('video')[0];
	if (videos) {
		videos.addEventListener('ended', function () {
			var buttons = $(this).siblings('.toggle-play');
			buttons.find('img.pause').hide();
			buttons.find('img.play').show();
		})
	}

	// TPI table code
	$('.page-tpi .facetwp-template').on('click', 'tr', function (e) {
		var row = jQuery(this);
		if (row.parents('table').css('display') === 'block') {
			row.toggleClass('shown');
			row.find('td:not(.false)').toggle();
		}
	})

	var forceSquare = function () {
		var shadow = $('.wp-block-columns > .wp-block-column .wp-block-columns .block-image-with-shadow.square .image-shadow-container');
		shadow.css('height', shadow.css('width'));
	}
	forceSquare();

});